// src/features/cart/cartSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
//import { ProductType } from "../../services/cartContext.types.tsx";
import ApiManager from "../../api/ApiManager.tsx";
import LocalStorage, { ADDITIONAL_NOTES } from "../../helpers/localStorage.ts";
import { AdditionalNoteTypes } from "../../features/Cart/Checkout/AdditionalNote.types.ts";
import { CartInitialStateInterface, CartProductType, DeliveryType } from "./cartSlice.types.ts";
import { fetchInit } from '../user/userSlice.ts';
import { validateShippingAddress } from "./checkoutSlice.ts";
import { roundToTwo } from '../../helpers/roundToTwo.tsx';

// Asynchronous actions
export const addProductToCart = createAsyncThunk('cart/addProduct', ({ id, quantity }: UpdateProductQuantityInterface) => ApiManager.addProduct(id, quantity))
export const clearCart = createAsyncThunk('cart/clearCart', () => ApiManager.clearCart());
export const fetchProducts = createAsyncThunk('cart/fetchProducts', () => ApiManager.fetchProducts());

export interface UpdateProductQuantityInterface {
    id: number,
    quantity: number
}

export const updateProductQuantity = createAsyncThunk(
    'cart/updateProductQuantity',
    ({ id, quantity }: UpdateProductQuantityInterface) => ApiManager.updateProductQuantity(id, quantity)
);

export const fetchDeliveryMethods = createAsyncThunk('cart/fetchDeliveryMethods', (data: object) => ApiManager.fetchDeliveryMethods(data));
export const placeOrder = createAsyncThunk('cart/placeOrder', (data: object) => ApiManager.placeOrder(data));

// Cart slice
const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        value: 0,
        valueGross: 0,
        vat: 0,
        vatAvailable: null,
        products: [],
        hash: null,
        orderWithin: null,
        estimatedDelivery: null,
        deliveryOptions: {
            packages: [],
            pallets: [], // //
            personal: [],
            individual: false,
            loading: false,
        },
        activeDeliveryOption: {
            packages: null,
            pallets: null,
            personal: null,
            individual: null,
        },
        additionalNotes: (new LocalStorage).get(ADDITIONAL_NOTES) as AdditionalNoteTypes,
        loading: false,
        error: null,
    } as CartInitialStateInterface,
    reducers: {
        addProduct(state, action) {
            const { id } = action.payload;
            state.hash = id
        },
        removeProduct(state, action) {
            state.products = state.products.filter((product: CartProductType) => product.id !== action.payload);
        },
        setDeliveryMethods(state, action) {
            state.deliveryOptions = action.payload;
        },
        setActiveDeliveryMethod(state, action) {
            const { type, method }: { type: DeliveryType, method: number | null } = action.payload;

            state.activeDeliveryOption[type] = method;

            if (type === 'personal') {
                state.activeDeliveryOption.packages = null;
                state.activeDeliveryOption.pallets = null;
                state.activeDeliveryOption.individual = null;
            } else if (type === 'individual') {
                state.activeDeliveryOption.packages = null;
                state.activeDeliveryOption.pallets = null;
                state.activeDeliveryOption.personal = null;
            } else {
                if (state.deliveryOptions.packages?.length && state.activeDeliveryOption.packages === null) {
                    state.activeDeliveryOption.packages = 0;
                }

                if (state.deliveryOptions.pallets?.length && state.activeDeliveryOption.pallets === null) {
                    state.activeDeliveryOption.pallets = 0;
                }

                state.activeDeliveryOption.personal = null;
            }

            if (type !== 'personal') {
                //if(state.)
            }
        },
        setAdditionalNotes: (state, action) => {
            state.additionalNotes = action.payload;
        },
        setProductQuantity(state, action) {
            const { id, quantity } = action.payload;
            const product = state.products.find((product: CartProductType) => product.id === id) as CartProductType | undefined;

            /* if (!product) {
                product = state.products.packages.find((product: ProductType) => product.id === id) as ProductType | undefined;
            } */

            if (product) {
                product.quantity = quantity;
                state.value = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.priceNetto * product.quantity), 0)
                state.valueGross = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.valueBrutto), 0)
                /* state.products.pallets.reduce((acc: number, product: ProductType) => acc + (product.priceBrutto * product.quantity), 0); */
            }
        },
        setProducts: (state, action) => {
            state.products = action.payload;

            state.value = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.priceNetto * product.quantity), 0)
            state.valueGross = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.valueBrutto), 0)
        },
        setVat: (state, action) => {
            state.vat = action.payload.vat;
            state.vatAvailable = action.payload.vies;
            //state.valueGross = roundToTwo(state.value * (1 + state.vat));
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInit.fulfilled, (state, action) => {
                if (typeof action.payload.config.vat !== 'number') {
                    return;
                }

                state.vat = action.payload.config.vat;
            })
            .addCase(clearCart.fulfilled, (state, action) => {
                state.products = Array.isArray(action.payload.products) ? action.payload.products : [];
                //state.vat = action.payload.vat;
                //state.hash = action.payload.hash;

                /* state.products.pallets = action.payload.pallets; */

                state.value = 0//state.products.reduce((acc: number, product: ProductType) => acc + roundToTwo(product.priceNetto * product.quantity), 0)
                /* +
                    state.products.pallets.reduce((acc: number, product: ProductType) => acc + (product.priceNetto * product.quantity), 0); */
                state.valueGross = 0//state.products.reduce((acc: number, product: ProductType) => acc + roundToTwo(product.valueBrutto), 0)
                state.loading = false
                /* state.valueGross = state.products.packages.reduce((acc: number, product: ProductType) => acc + (product.priceBrutto * product.quantity), 0) +
                state.products.pallets.reduce((acc: number, product: ProductType) => acc + (product.priceBrutto * product.quantity), 0); */
            })
            .addCase(fetchProducts.fulfilled, (state, action) => {
                state.products = Array.isArray(action.payload?.products) ? action.payload.products : [];
                state.vat = action.payload?.vat;
                state.hash = action.payload?.hash;
                state.orderWithin = action.payload?.orderWithin
                state.estimatedDelivery = action.payload?.estimatedDelivery
                /* state.products.pallets = action.payload.pallets; */

                state.value = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.priceNetto * product.quantity), 0) /* +
                    state.products.pallets.reduce((acc: number, product: ProductType) => acc + (product.priceNetto * product.quantity), 0); */
                state.valueGross = state.products.reduce((acc: number, product: CartProductType) => acc + roundToTwo(product.valueBrutto), 0)
                state.loading = false
                /* state.valueGross = state.products.packages.reduce((acc: number, product: ProductType) => acc + (product.priceBrutto * product.quantity), 0) +
                state.products.pallets.reduce((acc: number, product: ProductType) => acc + (product.priceBrutto * product.quantity), 0); */
            })
            /*.addCase(fetchPaymentMethods.fulfilled, (state, action) => {
                state.paymentMethods = action.payload;
                state.activePaymentMethod = {
                    id: action.payload[0].id,
                    name: action.payload[0].name
                };
            })*/
            .addCase(fetchDeliveryMethods.fulfilled, (state, action) => {
                state.deliveryOptions = action.payload;
                state.activeDeliveryOption = {
                    packages: null,
                    pallets: null,
                    personal: state.activeDeliveryOption.personal,
                    individual: null,
                }

                if (state.activeDeliveryOption.personal !== null) {
                    return;
                }

                if (state.deliveryOptions.individual) {
                    state.activeDeliveryOption.individual = 1;
                    return;
                }

                state.activeDeliveryOption.packages = (state.deliveryOptions.packages?.length) ? 0 : null;
                state.activeDeliveryOption.pallets = (state.deliveryOptions.pallets?.length) ? 0 : null;
            })
            .addCase(validateShippingAddress.fulfilled, (state) => {
                state.deliveryOptions.loading = false;
            })
            .addCase(validateShippingAddress.rejected, (state) => {
                state.deliveryOptions.loading = false;
            })
            .addCase(fetchDeliveryMethods.pending, (state) => {
                state.deliveryOptions.loading = true;
            })
    },
});

// Export actions and reducer
export const {
    setProducts,
    setProductQuantity,
    addProduct,
    removeProduct,
    setAdditionalNotes,
    setDeliveryMethods,
    setActiveDeliveryMethod,
    setVat,
    setLoading,
} = cartSlice.actions;
export default cartSlice.reducer;
